<template>
        <div class="d-flex align-items-center" v-if="request">
            <Status :status="request.status"/>
        </div>
</template>

<script>
import Status from '../Dashboard/components/Card/TableComponents/Status'
import { useRoomRequests, useRouter} from '../../core/hooks'
import {ref, watch} from '@vue/composition-api'

export default {
    components: {
        Status
    },
    props: {
        requests: Array,
        roomId: String,
        status: String
    },
    setup(props){

        const {request} = useRoomRequests(props.requests)

        const {route} = useRouter()

        watch(() => props.requests, (newVal, oldVal) => { 
            const index = newVal.findIndex(item => item.id === request.value.id)
            if(index !== -1) {
                request.value.status = newVal[index].status
            }
        })

        return {
            request
        }
    }
}
</script>